import "./App.css";
import "./styles/DoctorPortfolio.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DoctorPortfolio from "./pages/DoctorPortfolio";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DoctorPortfolio />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;